<button (click)="openDrawer()" *ngIf="!isDrawerOpen">
    <img src="assets/icons/drawer.svg" alt="Close" class="w-10 h-10">
</button>

<div class="fixed top-0 left-0 w-full h-full bg-white z-50 overflow-y-auto" *ngIf="isDrawerOpen">

    <div class="flex justify-between items-center border-b border-border py-4 px-4">
        <app-logo width="90" height="40"></app-logo>
        <button class="px-4 py-2 bg-primary-200 rounded-[16px] font-semibold text-center text-primary text-lg"
                (click)="openPlansPage()" title="{{ 'shared.add_billing' | transloco }}">
                {{trialDaysLeft}}
            </button>
        <button (click)="closeDrawer()">
            <img src="assets/icons/sidebar/arrow-left.svg" alt="{{ 'shared.close' | transloco }}" class="w-10 h-10">
        </button>
    </div>

    <nav class="flex flex-col mt-4 h-full">
        @if(hasDashboardViewPermission)
        {
        <a routerLink="/dashboard" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
            [ngClass]="[selectedItemId == 0 ? 'text-primary' : 'text-neutral-500']">
            <img [src]="selectedItemId == 0 ? 'assets/icons/sidebar/dashboard-selected.svg' : 'assets/icons/sidebar/dashboard.svg'"
                class="mr-4" alt="{{ 'shared.icon' | transloco }}">
            <span>{{ 'shared.pages.dashboard' | transloco }}</span>
        </a>
        }
        <a routerLink="/invoice" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
            [ngClass]="[selectedItemId == 1 ? 'text-primary' : 'text-neutral-500']">
            <img [src]="selectedItemId == 1 ? 'assets/icons/sidebar/invoice-check-selected.svg' : 'assets/icons/sidebar/invoice-check.svg'"
                class="mr-4" alt="{{ 'shared.icon' | transloco }}">
            <span>{{ 'shared.pages.invoice_check' | transloco }}</span>
        </a>
        <!-- 
        TODO: DSantek - Show optimization link when Non-Group clients are available
        Optimization section is hidden for product launch.
        <a routerLink="/optimization" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
            [ngClass]="[selectedItemId == 2 ? 'text-primary' : 'text-neutral-500']">
            <img [src]="selectedItemId == 2 ? 'assets/icons/sidebar/optimization-selected.svg' : 'assets/icons/sidebar/optimization.svg'"
                class="mr-4" alt="{{ 'shared.icon' | transloco }}">
            <span>{{ 'shared.pages.optimization' | transloco }}</span>
        </a>
        -->
        <a routerLink="/services" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
            [ngClass]="[selectedItemId == 3 ? 'text-primary' : 'text-neutral-500']">
            <img [src]="selectedItemId == 3 ? 'assets/icons/sidebar/solar-selected.svg' : 'assets/icons/sidebar/solar.svg'"
                class="mr-4" alt="{{ 'shared.icon' | transloco }}">
            <span>{{ 'shared.pages.services' | transloco }}</span>
        </a>
        <a routerLink="/locations" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
            [ngClass]="[selectedItemId == 4 ? 'text-primary' : 'text-neutral-500']">
            <img [src]="selectedItemId == 4 ? 'assets/icons/sidebar/locations-selected.svg' : 'assets/icons/sidebar/locations.svg'"
                class="mr-4" alt="{{ 'shared.icon' | transloco }}">
            <span>{{ 'shared.pages.locations' | transloco }}</span>
        </a>
        <a routerLink="/archive" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
            [ngClass]="[selectedItemId == 5 ? 'text-primary' : 'text-neutral-500']">
            <img [src]="selectedItemId == 5 ? 'assets/icons/sidebar/archive-selected.svg' : 'assets/icons/sidebar/archive.svg'"
                class="mr-4" alt="{{ 'shared.icon' | transloco }}">
            <span>{{ 'shared.pages.archive' | transloco }}</span>
        </a>

        <div class="mt-auto mb-auto">
            <a routerLink="/file-upload" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
                [ngClass]="[selectedItemId == 12 ? 'text-primary' : 'text-neutral-500']">
                <img [src]="selectedItemId == 12 ? 'assets/icons/sidebar/file-upload-selected.svg' : 'assets/icons/sidebar/file-upload.svg'"
                    class="mr-4" alt="{{ 'shared.icon' | transloco }}">
                <span>{{ 'shared.pages.file_upload' | transloco }}</span>
            </a>
            <a routerLink="/settings" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
                [ngClass]="[selectedItemId == 13 ? 'text-primary' : 'text-neutral-500']">
                <img [src]="selectedItemId == 13 ? 'assets/icons/sidebar/settings-selected.svg' : 'assets/icons/sidebar/settings.svg'"
                    class="mr-4" alt="{{ 'shared.icon' | transloco }}">
                <span>{{ 'shared.pages.settings' | transloco }}</span>
            </a>
            <a routerLink="/auth/logout" class="flex items-center rounded-md py-4 px-4 hover:bg-primary-200"
                [ngClass]="[selectedItemId == 14 ? 'text-primary' : 'text-neutral-500']">
                <img [src]="selectedItemId == 14 ? 'assets/icons/sidebar/logout-selected.svg' : 'assets/icons/sidebar/logout.svg'"
                    class="mr-4" alt="{{ 'shared.icon' | transloco }}">
                <span>{{ 'shared.components.logout' | transloco }}</span>
            </a>
        </div>

    </nav>
</div>